const NUMBERS_REGEX = /^\d+$/;

export const stringOnlyContainsNumbers = (string: string) => NUMBERS_REGEX.test(string);
